import { Injectable } from '@angular/core';
import { loaderTypes } from '@app/shared/component/loader/loader';
import { map } from 'rxjs/operators';
import { AmplifyHttpClient } from '../auth/http.amplify-httpclient';
import { DocumentService } from '../vault/document.service';
@Injectable({
  providedIn: 'root',
})
export class DiscoveryService {
  constructor(private readonly httpService: AmplifyHttpClient, private documentService: DocumentService) {}

  getDocumentsList() {
    let url = `api/onboarding/documents`;
    const vaultid = this.documentService.getVaultId();
    const w_id = this.documentService.getWorSpaceId();
    
    // Check if we're in mydata context by looking at the current URL
    const currentUrl = window.location.href;
    const isMyDataContext = currentUrl.includes('/mydata/');
    
    if (isMyDataContext) {
      // In mydata context, don't include vaultid parameter
      if (w_id != null) {
        url = url + `?w_id=${w_id}`;
      }
    } else {
      // In vault context, include vaultid parameter
      if (vaultid != null) {
        url = url + `?vaultid=${vaultid}`;
      }
      if (w_id != null) {
        url = url + `?w_id=${w_id}`;
      }
    }

    return this.httpService.get<any>(url, null, loaderTypes.mainAnimation).pipe(
      map((response) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getAttachmentChecklistPdf() {
    let url = `api/onboarding/attachment-checklist-pdf`;
    const vaultid = this.documentService.getVaultId();
    const w_id = this.documentService.getWorSpaceId();
    
    // Check if we're in mydata context by looking at the current URL
    const currentUrl = window.location.href;
    const isMyDataContext = currentUrl.includes('/mydata/');
    
    if (isMyDataContext) {
      // In mydata context, don't include vaultid parameter
      if (w_id != null) {
        url = url + `?w_id=${w_id}`;
      }
    } else {
      // In vault context, include vaultid parameter
      if (vaultid != null) {
        url = url + `?vaultid=${vaultid}`;
      }
      if (w_id != null) {
        url = url + `?w_id=${w_id}`;
      }
    }
    return this.httpService.post<any>(url, null, loaderTypes.none).pipe(
      map((response) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getOnboardingChecklist() {
    return this.httpService.get<any>(`api/onboarding/onboarding-checklist`, null, loaderTypes.mainAnimation).pipe(
      map((response) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  setDiscoverySetupVault(request) {
    const url = `api/user/setup-step-vault`;
    return this.httpService.post(url, request, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  plural(word: string, amount?: number): string {
    if (amount !== undefined && amount === 1) {
      return word;
    }
    const plural: { [key: string]: string } = {
      '(quiz)$': '$1zes',
      '^(ox)$': '$1en',
      '([m|l])ouse$': '$1ice',
      '(matr|vert|ind)ix|ex$': '$1ices',
      '(x|ch|ss|sh)$': '$1es',
      '([^aeiouy]|qu)y$': '$1ies',
      '(hive)$': '$1s',
      '(?:([^f])fe|([lr])f)$': '$1$2ves',
      '(shea|lea|loa|thie)f$': '$1ves',
      sis$: 'ses',
      '([ti])um$': '$1a',
      '(tomat|potat|ech|her|vet)o$': '$1oes',
      '(bu)s$': '$1ses',
      '(alias)$': '$1es',
      '(octop)us$': '$1i',
      '(ax|test)is$': '$1es',
      '([^su]+)s$': '$1s',
      '([^s]+)$': '$1s',
    };
    const irregular: { [key: string]: string } = {
      move: 'moves',
      foot: 'feet',
      goose: 'geese',
      sex: 'sexes',
      child: 'children',
      man: 'men',
      tooth: 'teeth',
      person: 'people',
      Condominium: 'Condominiums',
      Safe: 'Safes',
      Lens: 'Lenses',
    };
    const uncountable: string[] = [
      'sheep',
      'fish',
      'deer',
      'moose',
      'series',
      'species',
      'money',
      'rice',
      'information',
      'equipment',
      'bison',
      'cod',
      'offspring',
      'pike',
      'salmon',
      'shrimp',
      'swine',
      'trout',
      'aircraft',
      'hovercraft',
      'spacecraft',
      'sugar',
      'tuna',
      'you',
      'wood',
      'leased personal watercraft',
      'leased aircraft',
    ];
    // save some time in the case that singular and plural are the same
    if (uncountable.indexOf(word.toLowerCase()) >= 0) {
      return word;
    }
    // check for irregular forms
    for (const w in irregular) {
      const pattern = new RegExp(`${w}$`, 'i');
      const replace = irregular[w];
      if (pattern.test(word)) {
        return word.replace(pattern, replace);
      }
    }
    // check for matches using regular expressions
    for (const reg in plural) {
      const pattern = new RegExp(reg, 'i');
      if (pattern.test(word)) {
        return word.replace(pattern, plural[reg]);
      }
    }
    return word;
  }

  getOnBoardingTemplateSetup() {
    const url = `api/onboarding/setup`;
    return this.httpService.get(url, null, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getOnBoardingTemplateMaintenance(userId?: string) {
    const url = !userId ? `api/checklist/checklist-home` : `api/checklist/checklist-home/${userId}`;
    return this.httpService.get(url, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getDiscoveryType(profile = false) {
    let url = `api/onboarding/discovery-type`;
    if (profile) {
      url = url + `?profile=${profile}`;
    }
    return this.httpService.get(url, null, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getDiscoveryCategoryConfiguration(dataType) {
    const url = `api/onboarding/discovery-category-configuration/${dataType}`;
    return this.httpService.get(url, null, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getDiscoverySybType(id) {
    const url = `api/onboarding/discovery-sub-type/${id}`;
    return this.httpService.get(url, null, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  createDiscoveryType(body) {
    const url = `api/onboarding/discovery-type`;
    return this.httpService.post(url, body, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  completeDiscoveryType(body) {
    const url = `api/onboarding/discovery-type-complete`;
    return this.httpService.post(url, body, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  updateDiscoveryType(body) {
    const url = `api/onboarding/discovery-type`;
    return this.httpService.patch(url, body, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  createDiscoverySubType(body) {
    const url = `api/onboarding/discovery-sub-type`;
    return this.httpService.post(url, body, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  deleteDiscoverySubType(body) {
    const url = `api/onboarding/delete-discovery-sub-type`;
    return this.httpService.post(url, body, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getDiscoverySubTypeContent(sub_Type) {
    const url = `api/onboarding/discovery/${sub_Type}`;
    return this.httpService.get(url, null, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getDiscoverySubTypeById(typeId, subTypeId) {
    const url = `api/onboarding/discovery-sub-type/${typeId}/${subTypeId}`;
    return this.httpService.get(url, null, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  updateDiscoverySubType(payload) {
    const url = `api/onboarding/discovery-sub-type`;
    return this.httpService.patch(url, payload, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getDiscoveryConfiguration(dataType) {
    const url = `api/onboarding/discovery-configuration/${dataType}`;
    return this.httpService.get(url, null, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getDiscoveryFinancialAccount() {
    const url = `api/onboarding/discovery-financial-account`;
    return this.httpService.get(url, null, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  createDiscoveryFinancialAccount(body) {
    const url = `api/onboarding/discovery-financial-account`;
    return this.httpService.post(url, body, loaderTypes.none).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  deleteDiscoveryFinancialAccount(id) {
    const url = `api/onboarding/discovery-financial-account/${id}`;
    return this.httpService.delete(url, null, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getAllUserFormByDiscoveryFinancialAccountId() {
    const url = `api/onboarding/user-form-by-discovery-financial-account-id`;
    return this.httpService.get(url, null, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  updateDiscoveryFinancialAccount(id, body) {
    const url = `api/onboarding/discovery-financial-account/${id}`;
    return this.httpService.patch(url, body, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        return response;
      })
    );
  }
}
